import { UiControl } from './ui-control.model';
import { UiColumn } from './../ui-column';
import { SelectFilter } from '../../interfaces/select-filters/select-filter.interface';
import { OnChangeArgs } from '../../components/select-field/select-field.component';

export class SelectControl extends UiControl<Array<any> | null> {

  data: Array<any> = [];
  originalData: Array<any> = [];
  singleValue: any;
  previousValue: any;
  valueMember: string;
  displayMember: string;
  placeHolder: string;
  noResultMessage: string;
  allowMultiple: boolean;
  maxResults: number;
  maxResultsMessage: string;
  forceDataLoadOnOpen: boolean;
  minimumCharacterLength: number | null;
  apiController: string;
  customEndpoint: string;
  columns: UiColumn[] = [];
  singleColumnMember: string;
  filters: SelectFilter = {};
  performSearch: boolean;
  postAsDisplayName: boolean = false;
  clearDataOnOpen: boolean = false; // This is mostly used for the EntityTypeAttribute component where we continuously have to modify the Filters and search for different things on the same select
  onchange: (e: OnChangeArgs) => void;
  sameValueAndDisplayMembers: boolean; // Set this to true when the select field uses the same property for value and display

  constructor(id: string, label: string, value: any, isArray?: boolean, onlyShowThisColumn?: string);
  constructor(id: string, label: string, values: Array<any>, isArray?: boolean, onlyShowThisColumn?: string);
  constructor(...arr: any[]) {
    var id = arr[0];
    var label = arr[1];
    var values = arr[2];
    var data: Array<any> = [];
    var isArray: boolean = arr[3];

    if (isArray) {
      data = values;
    } else {
      data.push(values);
    }

    super(id, label, data, isArray);

    this.className = "SelectControl";
    this.singleColumnMember = arr[4];
    this.originalValue = values[0];
    this.previousValue = values[0];
    this.singleValue = values[0];
    this.allowMultiple = isArray;
    this.placeHolder = "Select a Value";
    this.noResultMessage = "No data found";
    this.maxResults = 250;
    this.maxResultsMessage = "Too many results to load. Enter more characters";
    this.minimumCharacterLength = 0;
    this.performSearch = true;
    this.originalData = this.data;
    this.sameValueAndDisplayMembers = false;
  }

  getValue(): string {
    if (this.allowMultiple) {
      if (this.value) {
        return this.value.filter(v => v[this.valueMember]).join(',');
      }
      return "";
    } else {
      if (this.singleValue) {
        return this.singleValue[this.valueMember];
      }
      return "";
    }
  }

  getNullableValue(): any {
    if (this.allowMultiple) {
      if (this.value) {
        return this.value.filter(v => v[this.valueMember]).join(',');
      }
      return null;
    } else {
      if (this.singleValue) {
        return this.singleValue[this.valueMember];
      }
      return null;
    }
  }

  getTextValue(): string {
    if (this.allowMultiple) {
      if (this.value) {
        return this.value.filter(v => v[this.displayMember]).join(',');
      }
      return "";
    } else {
      if (this.singleValue) {
        return this.singleValue[this.displayMember];
      }
      return "";
    }
  }

  getColumnSizeInPercentage(fieldName: string): string {
    if (this.columns.length == 1) {
      return "100%";
    }

    var column = this.columns.find(f => f.field == fieldName);
    if (column) {
      var totalSize = this.sum(this.columns, "size");
      var columnSize = column.size;
      var percent = ((columnSize / totalSize) * 100).toFixed();
      return percent + "%";
    }

    return "15%";
  }

  sum(arr: any[], prop: string): number {
    var total = 0;

    for (var i = 0; i < arr.length; i++) {
      total += arr[i][prop];
    }

    return total;
  }
}
